import { render, staticRenderFns } from "./tab-5-record-live.vue?vue&type=template&id=7d3842c0&scoped=true&lang=pug&"
import script from "./tab-5-record-live.vue?vue&type=script&lang=js&"
export * from "./tab-5-record-live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3842c0",
  null
  
)

export default component.exports